import { useParams } from "react-router-dom";
import {
  AddNewAnnualProcurementPlanForm,
  AddNewAnnualProcurementPlanHeader,
} from "./components";
import { useAnnualProcurementPlan } from "@hooks/procurements/annualProcurementPlan/useAnnualProcurementPlan";
import { AnnualProcurementResponseType } from "@type/procurements/annualProcurementPlan";

export default function AddNewAnnualProcurementPlan() {
  const { id } = useParams();
  const { annualProcurementPlanState } = useAnnualProcurementPlan(id as string);

  const { getSingleData } =
    annualProcurementPlanState || ({} as AnnualProcurementResponseType);

  return (
    <div className="p-10 d-grid">
      <AddNewAnnualProcurementPlanHeader data={id ? getSingleData : null} />
      <AddNewAnnualProcurementPlanForm
        procurement={id ? getSingleData : null}
        id={id as string | number}
      />
    </div>
  );
}
